export default  {
  count (state) {
    return state.count
  },
  list (state) {
    return state.list
  },
  suppliers (state) {
    return state.suppliers
  },
  match (state) {
    return state.match
  },
  matchCount (state) {
    return state.list.length
  },
  modified: state => state.modified,
   item: state => index => state.list.filter(e => e._id === index)[0],
   question: state => state.question,
   currentQuestion: state => state.question,
   search: state => state.search
}